import { getThumbBySize } from '../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';
import { getUtmParamsForQrCodeUrl } from '../../../AlbumFolder/AlbumFolderMarketing/components/AccountMarketingMaterialPrintTemplate/helpers';

/**
 * Calculates the duration of the slideshow or a portion of it
 *
 * @param {Array} [slides] The slides array
 * @param {Number} [defaultDuration] The slideshow's default MS duration
 * @param {Number} [stopIndex] The stop index, given we want the time up to a certain slide
 */
export const calculateSlideshowDuration = (
  slides,
  defaultDuration,
  stopIndex = null,
) => {
  if (!slides) {
    return 0;
  }

  if (stopIndex !== null) {
    return slides.slice(0, stopIndex).reduce(sum => sum + defaultDuration, 0);
  }

  return slides.reduce(sum => sum + defaultDuration, 0);
};

/**
 * Retrieves the appropriate Slide image URL based off the given slide data
 *
 * @param {Object} slide the slideshow's slide to get the image for
 * @param {String} imageSizeCode the image size code to get the thumb for if getting thumbs
 *
 * @returns {string} the appropriate thumbnail or asset image URL
 */
export const getSlideImageUrl = (
  slide,
  imageSizeCode = IMAGE_SIZE_CODE.SMALL2X,
) => {
  if (!slide) {
    return '';
  }

  if (slide.photo) {
    const thumbnail = getThumbBySize(
      slide.photo.watermarked_urls ?? slide.photo.thumbnail_urls,
      imageSizeCode,
    );

    return thumbnail?.url;
  }

  if (slide.asset_image) {
    return slide.asset_image.url;
  }

  return '';
};

/**
 * Determines if a given slideshowSlide is an intro Layout.
 *
 * @param {Object} slideshowSlide the slideshow slide
 *
 * @returns {boolean}
 */
export const isIntroLayout = slideshowSlide => {
  if (!slideshowSlide) {
    return false;
  }

  return !!slideshowSlide.account_card && slideshowSlide.display_order === -1;
};

/**
 * Given a baseURL and an album, build the appropriate slideshow QR Code URL
 *
 * @param {String} baseURL the base URL
 * @param {Object} album the album the slideshow belongs to
 *
 * @returns {String}
 */
export const getSlideshowQRInsertUrl = (baseURL, album) => {
  if (!album || !baseURL || !album?.auto_contributor_share_url) {
    return '';
  }

  return getUtmParamsForQrCodeUrl({
    url: `${album.auto_contributor_share_url}?mms=1`,
    albumFolder: album.root_album_folder,
  });
};
